import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { API_BASE_URL } from '@/utils/api'

if (typeof window !== 'undefined') {
  window.Pusher = Pusher
}

const reverbKey = import.meta.env.VITE_REVERB_APP_KEY
const reverbHost = import.meta.env.VITE_REVERB_HOST
const reverbPort = import.meta.env.VITE_REVERB_PORT ?? 8080
const reverbScheme = import.meta.env.VITE_REVERB_SCHEME ?? 'http'

/**
 * Crea una instancia de Laravel Echo configurada para Reverb (WebSocket local).
 * Solo se usa cuando BROADCAST_CONNECTION=reverb y hay clave configurada.
 */
export function createEcho() {
  if (!reverbKey) {
    return null
  }
  return new Echo({
    broadcaster: 'reverb',
    key: reverbKey,
    wsHost: reverbHost,
    wsPort: reverbPort,
    wssPort: reverbPort,
    forceTLS: reverbScheme === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${API_BASE_URL}/api/v1/broadcasting/auth`,
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        const body = new URLSearchParams({
          socket_id: socketId,
          channel_name: channel.name,
        })
        fetch(`${API_BASE_URL}/api/v1/broadcasting/auth`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body,
          credentials: 'include',
        })
          .then(async (res) => {
            const data = await res.json().catch(() => ({}))
            if (!res.ok) {
              console.error('[Reverb] Auth falló:', res.status, data)
              callback(true, data)
              return
            }
            callback(false, data)
          })
          .catch((err) => {
            console.error('[Reverb] Error en auth:', err)
            callback(true, err)
          })
      },
    }),
  })
}

let echoInstance = null

/**
 * Obtiene la instancia de Echo (singleton). Devuelve null si no hay key de Reverb.
 */
export function getEcho() {
  if (!reverbKey) return null
  if (!echoInstance) {
    echoInstance = createEcho()
  }
  return echoInstance
}
